import React from "react";
import styles from "../stylesERv2.module.scss";

/**
 * Detalle de la línea "Intereses" (debajo del EBIT) del ER v2, por MES y por MODO.
 *
 * Es mes-aware y moneda-aware: el caller (index.js) arma los `conceptos` de ESE mes en la
 * MISMA unidad que la celda (local × TC del mes, o USD en dólares/región) y este modal solo
 * los formatea con `prefijo`. Por eso el total del modal coincide con la celda por
 * construcción: Σ(conceptos.monto) es exactamente el valor que muestra la celda.
 *
 * Modo región: cada préstamo entra con la suma Chile+Perú (= el total holding del préstamo),
 * en USD, igual que la celda combina ambos países.
 *
 * Filas: `origen: "Holding"` (baseline del holding) + `origen: "Factoring"` (intereses reales
 * de factoring del mes, una por operación, ya convertidas a la unidad de la celda por el
 * caller). Cada fila puede traer un `sub` opcional (folio/fecha) que se muestra bajo el nombre.
 *
 * Sigue el molde de los demás modales del ER (overlay + modalContent + modalTable +
 * modalActions), con max-height/scroll heredado de las clases dedicadas (regla 10.135).
 */
export const InteresesModal = ({ isOpen, onClose, mes, conceptos = [], prefijo = "" }) => {
  if (!isOpen) return null;

  const fmt = (n) => `${prefijo}${Math.round(n || 0).toLocaleString("es-CL")}`;
  // El total se calcula de la suma cruda (redondeada una vez), no de las filas ya
  // redondeadas: así queda idéntico a la celda del ER, que redondea el total.
  const total = conceptos.reduce((sum, c) => sum + (c.monto || 0), 0);

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <h3>Intereses{mes ? ` — ${mes}` : ""}</h3>

        {conceptos.length === 0 ? (
          <p style={{ margin: "16px 0", color: "#666", fontSize: "0.9rem" }}>No hay intereses en este mes.</p>
        ) : (
          <table className={styles.modalTable}>
            <thead>
              <tr>
                <th style={{ textAlign: "left" }}>Concepto</th>
                <th style={{ textAlign: "center" }}>Origen</th>
                <th style={{ textAlign: "end" }}>Monto</th>
              </tr>
            </thead>
            <tbody>
              {conceptos.map((c, i) => (
                <tr key={`${c.origen}-${c.nombre}-${i}`}>
                  <td style={{ textAlign: "left", fontWeight: 500 }}>
                    {c.nombre}
                    {c.sub && <div style={{ color: "#888", fontSize: "0.78rem", fontWeight: 400 }}>{c.sub}</div>}
                  </td>
                  <td style={{ textAlign: "center", color: "#666", fontSize: "0.85rem" }}>{c.origen}</td>
                  <td style={{ textAlign: "end", fontVariantNumeric: "tabular-nums" }}>{fmt(c.monto)}</td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr>
                <td colSpan={2} style={{ textAlign: "end", fontWeight: 600 }}>
                  Total
                </td>
                <td style={{ textAlign: "end", fontWeight: 600, fontVariantNumeric: "tabular-nums" }}>{fmt(total)}</td>
              </tr>
            </tfoot>
          </table>
        )}

        <div className={styles.modalActions}>
          <button className={styles.btnClose} onClick={onClose}>
            Cerrar
          </button>
        </div>
      </div>
    </div>
  );
};
